<ion-list class = "reusable-form-component">
  <ion-item *ngFor="let option of options">
    <div class = "flex-layout main-wrapper" [class] = "{'reverse': reverse}">
      <span *ngIf="option.title" class = "subheading-normal text-italic right-spacing">{{ option.title }}</span>
      <div class = "flex-layout">
        <ion-checkbox *ngIf = "!hideCheckbox" [(ngModel)]="value"></ion-checkbox>
      </div>
      <div class = "flex-layout">
        <span *ngIf = "!hideCheckbox" class = "subheading-normal text-italic left-spacing">{{ option.label }}</span>
      </div>
    </div>
  </ion-item>
</ion-list>